// extracted by mini-css-extract-plugin
export default {"container":"T1-z","list":"U1-z"};